import { useState } from "react";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import pages from "../../../../constants/pages";
import { useAlert } from "../../../../hooks";
import { objectFromFormData, validationSchema } from "./campaignObject";
import { useDynamicSignatureAxios } from "../../../../hooks/useDynamicSignatureAxios";

export default function Form({
  agents,
  formData,
  editState,
  audiences,
  categories,
  setEditState,
  audienceSize,
  audienceData,
  connectionList,
  setAudienceData,
  preferredChannels,
  setAudienceCreated,
}) {
  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axios = useDynamicSignatureAxios();

  const [agentToken, setAgentToken] = useState({});

  const { activeBrand } = useSelector((state) => state.memberDetails);

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validationSchema={validationSchema}
      validateOnChange
      onSubmit={(formData, { setSubmitting }) => {
        let url = "/user/create/campaign";
        let method = "POST";
        if (!!formData.campaignID) {
          url = "/user/update/campaign/" + formData.campaignID;
          method = "PUT";
        }

        axios({
          url: url,
          method: method,
          data: objectFromFormData(formData, activeBrand),
          disableRedirect: true,
        })
          .then((res) => {
            if (res.status) {
              if (audienceData.ID !== formData.audienceID) {
                axios({
                  url: "/brand/getDetailsOfAudience/" + formData.audienceID,
                }).then(async (res) => {
                  if (res.status) {
                    let data = {};

                    for await (let key of res.data.fields) {
                      data[Object.keys(key)[0]] = {
                        value: Object.values(key)[0],
                        mandatory: Object.values(key)[1],
                      };
                    }

                    data = {
                      ...data,
                      ID: res.data.audience_id,
                      brandID: res.data.brand_id,
                    };

                    await setAudienceData(data);
                  }
                });
              }
              if (!!formData.campaignID) {
                dispatch(
                  alert({
                    message: "Campaign updated Successfully!",
                    type: "success",
                  })
                );

                setEditState(false);
              } else {
                dispatch(
                  alert({
                    message: "Campaign Created Successfully!",
                    type: "success",
                  })
                );

                navigate(pages.campaignDetails.route + res.data.campaign_id);
              }
            } else {
              dispatch(
                alert({
                  type: "error",
                  message: res.message?.errorMessage,
                })
              );
            }

            setSubmitting(false);
          })
          .catch((err) => {
            console.error(err);
          });
      }}
    >
      {(formikProps) => (
        <FormDisplay
          agentToken={agentToken}
          setAgentToken={setAgentToken}
          agents={agents}
          audienceSize={audienceSize}
          audiences={audiences}
          editState={editState}
          categories={categories}
          formikProps={formikProps}
          audienceData={audienceData}
          setEditState={setEditState}
          connectionList={connectionList}
          setAudienceData={setAudienceData}
          preferredChannels={preferredChannels}
          setAudienceCreated={setAudienceCreated}
        />
      )}
    </Formik>
  );
}
